import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetProjectsQuery } from "../../../features/api/apiSlice";
import { addProjects } from "../../../features/filter/filterSlice";
import Project from "./Project";

function Projects() {
  const { data, isLoading, isError, isSuccess } = useGetProjectsQuery();

  const dispatch = useDispatch();
  useEffect(() => {
    if (isSuccess) {
      const payload = data?.map((entry) => {
        return { ...entry, isChecked: true };
      });
      dispatch(addProjects(payload));
    }
  }, [isSuccess, dispatch, data]);

  const { projects } = useSelector((state) => state.filter);

  const [content, setContent] = useState(null);

  useEffect(() => {
    if (isLoading) setContent("Loading....");
    if (!isLoading && isError) setContent("Something Went Wrong!");
    if (!isLoading && !isError && projects?.length === 0)
      setContent("No Team member yet...");
    if (!isLoading && !isError && projects?.length > 0)
      setContent(
        projects?.map((project) => (
          <Project project={project} key={project?.id} />
        ))
      );
  }, [projects, isLoading, isError]);

  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
}

export default Projects;
